import React from "react";
import PropTypes from "prop-types";
import LineItemContentII from "./LineItemContentII";
import Loading from "../Loading/Loading";
import EditableLinks from "./EditableContent/EditableLinks";
import UpsellItems from "./UpsellItems";

import "./LineItemII.scss";

const LineItemII = (props) => {
  if (props.isLoading) {
    return <Loading dark relative small />;
  }
  return (
    <React.Fragment>
      <div className="line-item-ii-content-wrapper">
        <LineItemContentII {...props} />
      </div>
      {props.isMobile && (
        <>
          {props.isEnableUpsell && (
            <UpsellItems
              item={props.item}
              countryModel={props.model.countryModel}
              handleEditAddon={props.handleEditAddon}
              availableAddons={
                props.isEnableUpsell ? props.availableAddons : []
              }
            />
          )}
          <EditableLinks {...props} />
        </>
      )}
    </React.Fragment>
  );
};

LineItemII.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isEnableUpsell: PropTypes.bool,
  item: PropTypes.object,
  model: PropTypes.shape({
    countryModel: PropTypes.object,
  }),
  handleEditAddon: PropTypes.func,
  availableAddons: PropTypes.array,
};

export default LineItemII;
